import React from "react";
import PropTypes from "prop-types";
import KnownOutageEventNotification from "../../../components/KnownOutageEventNotification/KnownOutageEventNotification";
import OutageStatusNotification from "../../../components/OutageStatusNotification/OutageStatusNotification";
import {
  OUTSIDE_NETWORK,
  PLANNED,
  REPORTED,
  UNKNOWN,
  UNPLANNED,
} from "../../../components/OutageStatusType";
import { getOutageStatusText } from "./GetOutageStatusText";
import getOutageStatusType from "./OutageStatusTypeMapper";

export const OutageStatusBar = ({
  eventType,
  outageId,
  serviceRequestNumber,
  outsideVectorNetwork,
  preliminaryEtrType,
}) => {
  const outageStatusType = getOutageStatusType(
    eventType,
    outageId,
    outsideVectorNetwork,
  );

  const outageStatus = getOutageStatusText(
    outageStatusType,
    preliminaryEtrType,
  );

  switch (outageStatusType) {
    case REPORTED:
    case UNKNOWN:
    case OUTSIDE_NETWORK:
      return (
        <OutageStatusNotification
          variant="warning"
          notification={outageStatus}
        />
      );

    case UNPLANNED:
    case PLANNED:
      return (
        <KnownOutageEventNotification
          outageId={outageId}
          serviceRequestNumber={serviceRequestNumber}
          outageStatus={outageStatus}
          preliminaryEtrType={preliminaryEtrType}
          data-testid={`planned-outage-${outageId}`}
          outageStatusType={outageStatusType}
        />
      );

    default:
      return null;
  }
};

OutageStatusBar.propTypes = {
  eventType: PropTypes.oneOf(["Planned", "UnPlanned", "UNKNOWN"]).isRequired,
  outageId: PropTypes.string.isRequired,
  serviceRequestNumber: PropTypes.string.isRequired,
  outsideVectorNetwork: PropTypes.bool.isRequired,
};
